import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import Banner from "../../assets/images/appImages/img-banner.png";
import Deco from "../../assets/images/appImages/deco.png";

function BannerHomepage() {
  let location = useLocation();
  let path = location?.pathname;
  return (
    <section className="section-banner-homepage">
      <div className="row align-items-center">
        <div className="col-md-12 col-right-banner-accueil">
          <div className="content-col-right-banner-accueil">
            <div className="container-img-col-right-banner-accueil text-center">
              <img
                loading="lazy"
                src={Banner}
                alt="Banniere"
                className="img-col-right-banner-accueil"
              />
            </div>
            <div className="container-img-deco-banner">
              {/*  */}
            </div>
          </div>
        </div>
        <div className="col-md-12 col-left-banner-accueil mb-3">
          <div className="content-col-left-banner-accueil text-center">
            <h2 className="mb-0 title-home-page pb-4">
              Bien être Ancestral pour la vie moderne
            </h2>
            <div className="container-btn-banner-accueil">
              <NavLink className="btn btn-title-home-page text-white" to="/produits">
                Voir nos produits
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <div className="blank_filter"></div>

      {/* Bandeau scrollant */}
      <div className="scrolling-info-banner">
        <div className="scrolling-info-content">
          <span className="scrolling-info-item">  Conditions de livraison :</span>
          <span className="scrolling-info-item"> Groupage Dakar : 2 000 FCFA (jusqu’à 3 jours)</span>
          <span className="scrolling-info-item">Express Dakar : 5 000 FCFA (max 5h)</span>
          <span className="scrolling-info-item"> Hors Dakar : selon le transporteur</span>
        </div>
      </div>
    </section>
  );
}

export default BannerHomepage;